export default __webpack_public_path__ + "static/media/ray-white.33dd1eeb.jpeg";